import React from 'react';
import { Link } from 'react-router-dom';

const ServicesPage = () => {
  const landscapingServices = [
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      ),
      title: "Residential Landscaping",
      description: "Complete landscape design and installation for your dream outdoor space."
    },
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
        </svg>
      ),
      title: "Commercial Landscaping", 
      description: "Professional landscaping solutions for businesses and commercial properties."
    },
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z"/>
        </svg>
      ),
      title: "Lawn Care & Maintenance",
      description: "Professional lawn care, seasonal cleanup, and ongoing maintenance services."
    }
  ];

  const hardscapingServices = [
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12,2L3.09,8.26L4.11,21.53L12,17.27L19.89,21.53L20.91,8.26L12,2M12,4.87L17.5,8.6L16.5,19.4L12,16.15L7.5,19.4L6.5,8.6L12,4.87Z"/>
        </svg>
      ),
      title: "Retaining Walls",
      description: "Structural and decorative retaining walls built with premium materials."
    },
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.9L16.2,16.2Z"/>
        </svg>
      ),
      title: "Patios & Walkways",
      description: "Beautiful outdoor living spaces with natural stone, brick, and pavers."
    },
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19.5,19.5L21,21L19.5,22.5L18,21L19.5,19.5M17,8.5L8.5,17L6.5,15L15,6.5L17,8.5M19,3L21,5L17,9L15,7L19,3M3,17.5L4.5,19L8,15.5L6.5,14L3,17.5Z"/>
        </svg>
      ),
      title: "Stone Fire Pits",
      description: "Custom fire pit installations for cozy evenings and entertaining."
    },
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12,6A6,6 0 0,1 18,12C18,14.22 16.79,16.16 15,17.2V19A1,1 0 0,1 14,20H10A1,1 0 0,1 9,19V17.2C7.21,16.16 6,14.22 6,12A6,6 0 0,1 12,6M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z"/>
        </svg>
      ),
      title: "Outdoor Kitchens",
      description: "Complete outdoor cooking spaces with grills, countertops, and storage."
    },
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M9,3C6.2,3 4,5.2 4,8V16C4,18.8 6.2,21 9,21H15C17.8,21 20,18.8 20,16V8C20,5.2 17.8,3 15,3H9M12,7C10.9,7 10,7.9 10,9V15C10,16.1 10.9,17 12,17S14,16.1 14,15V9C14,7.9 13.1,7 12,7Z"/>
        </svg>
      ),
      title: "Pergolas & Arbors",
      description: "Elegant shade structures and garden architecture installations."
    },
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z"/>
        </svg>
      ),
      title: "Swimming Pools",
      description: "Custom pool design and installation with surrounding landscape."
    }
  ];

  const gardenCenterProducts = [
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17,8C8,10 5.9,16.17 3.82,21.34L5.71,22L6.66,19.7C7.14,19.87 7.64,20 8,20C19,20 22,3 22,3C21,5 14,5.25 9,6.25C4,7.25 2,11.5 2,13.5C2,15.5 3.75,17.25 3.75,17.25C7,8 17,8 17,8Z"/>
        </svg>
      ),
      title: "Trees & Shrubs",
      description: "Extensive selection of native and ornamental trees and shrubs."
    },
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12,2L13.09,8.26L19,9L14.18,13L19.09,19L12,16.9L4.91,19L9.82,13L5,9L10.91,8.26L12,2Z"/>
        </svg>
      ),
      title: "Annuals & Perennials", 
      description: "Seasonal flowers and plants for year-round garden beauty."
    },
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,19H5V5H19V19Z"/>
        </svg>
      ),
      title: "Native Plants",
      description: "Locally adapted plants that thrive in Central Virginia's climate."
    },
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M11,6H13V10.5L15.5,12L13,13.5V18H11V13.5L8.5,12L11,10.5V6Z"/>
        </svg>
      ),
      title: "Bulk Materials",
      description: "Mulch, topsoil, compost, and other landscaping materials."
    },
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12,2L2,7L12,12L22,7L12,2M2,17L12,22L22,17M2,12L12,17L22,12"/>
        </svg>
      ),
      title: "Christmas Shop",
      description: "Holiday trees, wreaths, and seasonal decorations."
    },
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12.5,7H11V13.17L16.17,16.17L17.5,14.83L12.5,9.83V7Z"/>
        </svg>
      ),
      title: "Container Gardens",
      description: "Custom planter arrangements and ready-made container gardens."
    }
  ];

  const designServices = [
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"/>
        </svg>
      ),
      title: "3D Design",
      description: "Visualize your project with professional 3D rendering and modeling."
    },
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
        </svg>
      ),
      title: "Master Plans",
      description: "Comprehensive landscape plans for large-scale projects and developments."
    },
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19,19H5V5H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M16,16H8V8H16V16Z"/>
        </svg>
      ),
      title: "Landscape Architects",
      description: "Expert architectural planning and design for complex landscape projects."
    }
  ];

  return (
    <div className="ServicesPage">
      {/* Hero Section for Services */}
      <section className="section" style={{ 
        background: 'linear-gradient(135deg, var(--primary-100), var(--background-surface))',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 style={{ color: 'var(--primary-700)' }}>Our Services</h1>
          <p style={{ fontSize: 'var(--text-lg)', maxWidth: '800px', margin: '0 auto' }}>
            From comprehensive landscape design to premium garden center products, 
            Snow's Garden Center provides complete outdoor solutions for Central Virginia.
          </p>
        </div>
      </section>

      {/* Landscaping Services */}
      <section className="section">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 'var(--space-xxxl)' }}>
            <h2>Landscaping Services</h2>
            <p style={{ fontSize: 'var(--text-lg)', color: 'var(--neutral-400)', maxWidth: '600px', margin: '0 auto' }}>
              Transform your property with our comprehensive landscaping services, from initial design to ongoing maintenance.
            </p>
          </div>
          
          <div className="grid grid-cols-3">
            {landscapingServices.map((service, index) => (
              <div key={index} className="card service-card">
                {service.icon}
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Hardscaping Services */}
      <section className="section" style={{ backgroundColor: 'var(--background-surface)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 'var(--space-xxxl)' }}>
            <h2>Hardscaping</h2>
            <p style={{ fontSize: 'var(--text-lg)', color: 'var(--neutral-400)', maxWidth: '600px', margin: '0 auto' }}>
              Create stunning outdoor living spaces with our professional hardscaping services using premium materials and expert craftsmanship.
            </p>
          </div>
          
          <div className="grid grid-cols-3">
            {hardscapingServices.map((service, index) => (
              <div key={index} className="card service-card">
                {service.icon}
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Garden Center Products */}
      <section className="section">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 'var(--space-xxxl)' }}>
            <h2>Garden Center Products</h2>
            <p style={{ fontSize: 'var(--text-lg)', color: 'var(--neutral-400)', maxWidth: '600px', margin: '0 auto' }}>
              Central Virginia's premier source for quality plants, materials, and gardening supplies.
            </p>
          </div>
          
          <div className="grid grid-cols-3">
            {gardenCenterProducts.map((product, index) => (
              <div key={index} className="card service-card">
                {product.icon}
                <h3 className="service-title">{product.title}</h3>
                <p className="service-description">{product.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Design Services */}
      <section className="section" style={{ backgroundColor: 'var(--background-surface)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 'var(--space-xxxl)' }}>
            <h2>Design Services</h2>
            <p style={{ fontSize: 'var(--text-lg)', color: 'var(--neutral-400)', maxWidth: '600px', margin: '0 auto' }}>
              Professional planning and visualization services to bring your outdoor vision to life.
            </p>
          </div>
          
          <div className="grid grid-cols-3">
            {designServices.map((service, index) => (
              <div key={index} className="card service-card">
                {service.icon}
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="section">
        <div className="container">
          <div className="card" style={{ 
            textAlign: 'center',
            background: 'var(--primary-100)',
            border: '2px solid var(--primary-500)'
          }}>
            <h2 style={{ color: 'var(--primary-700)', marginBottom: 'var(--space-md)' }}>
              Additional Services
            </h2>
            <p style={{ marginBottom: 'var(--space-lg)' }}>
              We also offer sodding, seeding, tree and shrub care, seasonal cleanup, permeable pavers, 
              fencing, artificial turf, masonry work, and much more.
            </p>
            <p style={{ fontSize: 'var(--text-sm)', color: 'var(--neutral-400)', marginBottom: 'var(--space-xl)' }}>
              Don't see what you're looking for? Contact us to discuss your specific project needs.
            </p>
            <Link to="/contact" className="btn btn-primary">
              Discuss Your Project
            </Link>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section" style={{ backgroundColor: 'var(--background-surface)' }}>
        <div className="container">
          <div style={{ textAlign: 'center' }}>
            <h2>Ready to Get Started?</h2>
            <p style={{ fontSize: 'var(--text-lg)', color: 'var(--neutral-400)', marginBottom: 'var(--space-xl)', maxWidth: '600px', margin: '0 auto var(--space-xl)' }}>
              Schedule a free consultation to discuss your landscaping project and discover how we can transform your outdoor space.
            </p>
            <div style={{ display: 'flex', gap: 'var(--space-md)', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/contact" className="btn btn-primary">
                Schedule Free Consultation
              </Link>
              <a href="tel:434-295-2159" className="btn btn-secondary">
                Call (434) 295-2159
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;